import {DetailsList, FontSizes, FontWeights, IconButton, SelectionMode, Stack} from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import * as React from "react";
import {useContext} from "react";

function UserDocumentRestriction(props) {
    const [user] = useContext(AuthContext);

    const columns = [
        {
            key: 'document',
            name: 'Typ Dokumentu',
            ariaLabel: 'Ograniczenie Dokumentów Użytkownika',
            fieldName: 'document',
            minWidth: 240,
            isRowHeader: true,
            isResizable: true
        },
        {
            key: 'delete',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'delete',
            minWidth: 50,
            onRender: (item) => (<span>
                <IconButton iconProps={{iconName: 'trash'}} title='Usuń' onClick={() => _delete(item)}/>
            </span>)
        }
    ];

    const _delete = (document) => {
        fetch(`/api/user/${document.user_id}/document/${document.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.refresh();
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (<Stack.Item>
        <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
        <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
    </Stack.Item>);
}

UserDocumentRestriction.defaultProps = {
    title: 'Ograniczenia Dokumentów Użytkownika'
}

export default UserDocumentRestriction;